import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { addLayoutClass, removeLayoutClass } from './layoutSlice'

const useLayoutClass = className => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (className) {
      dispatch(addLayoutClass(className))
    }
    return () => {
      if (className) {
        dispatch(removeLayoutClass(className))
      }
    }
  }, [dispatch, className])
}

useLayoutClass.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
}

export default useLayoutClass
